import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { EditFeature } from '../../+state';

@NgModule({
    providers: [provideState(EditFeature.state), provideEffects([EditFeature.effects])],
})
export default class EditModule {}
